import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info);
    this.setState({ info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 3 }}>
          <Paper sx={{ p: 3, borderLeft: '4px solid', borderColor: 'error.main' }}>
            <Typography variant="h5" sx={{ mb: 1, color: 'error.main', fontWeight: 700 }}>
              Something broke on this page
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              The page hit an error during render. Copy the text below and send it to support — it tells us exactly what went wrong so we can fix it.
            </Typography>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                fontFamily: 'monospace',
                fontSize: '0.8rem',
                backgroundColor: '#fff5f5',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                mb: 2,
                maxHeight: 300,
                overflow: 'auto',
              }}
            >
              {this.state.error?.message || String(this.state.error)}
              {this.state.error?.stack && `\n\n${this.state.error.stack}`}
            </Paper>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button variant="contained" onClick={() => window.location.reload()}>
                Reload page
              </Button>
              <Button variant="outlined" onClick={() => window.history.back()}>
                Back
              </Button>
            </Box>
          </Paper>
        </Box>
      );
    }
    return this.props.children;
  }
}
